import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';

export const UnsavedChangesRedirectModal = ({
  isOpen,
  onClose,
  onDiscard,
  onSave,
}: {
  isOpen: boolean;
  onClose: () => void;
  onDiscard: () => void;
  onSave: () => void;
}) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="Save your changes?"
    modalClassName="w-full md:w-[670px]"
    centerContent={true}
  >
    <div className="flex flex-col gap-6">
      <Typography variant="body" size="large" fontWeight="normal">
        You have unsaved changes. If you leave now, your edits will be lost.
      </Typography>
      <div className="flex gap-4 justify-center">
        <Button
          variant="text"
          color="neutral"
          onClick={onDiscard}
          className="w-[180px]"
        >
          Discard changes
        </Button>
        <Button color="primary" onClick={onSave} className="w-[180px]">
          Save
        </Button>
      </div>
    </div>
  </Modal>
);
